import { render, staticRenderFns } from "./Izvestai.vue?vue&type=template&id=718b9326&scoped=true"
import script from "./Izvestai.vue?vue&type=script&lang=js"
export * from "./Izvestai.vue?vue&type=script&lang=js"
import style0 from "./Izvestai.vue?vue&type=style&index=0&id=718b9326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718b9326",
  null
  
)

export default component.exports